export const productsSliderOptions = (instance, options, maxItems, spaceBetween) => {
    let responsiveItemCounts = {
        1360: 6,
        1200: 5,
        1024: 4,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));
        
        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,  
        }
    }
   
    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: Number(spaceBetween),
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}

export const articleProductsSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 3,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 20,
            cssMode: false,
            pagination: {
                dynamicBullets: false,
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        cssMode: true,
        breakpoints: breakpoints
    }
}

export const accessoriesSliderOptions = (instance, options) => {
    let responsiveSpaceBetween = {
        1024: 142,
    }

    let breakpoints = {}

    for (const resolution in responsiveSpaceBetween) {
        const space = responsiveSpaceBetween[resolution]

        breakpoints[resolution] = {
            slidesPerView: 3,
            spaceBetween: space,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 20,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}

export const indexArticleSliderOptions = (instance, options) => {
    let responsiveItemCounts = {
        1024: 3,
        599: 2,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = responsiveItemCounts[resolution]

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: count,
            spaceBetween: 30,
            cssMode: false,
        }
    }

    return {
        loop: false,
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 15,
        cssMode: false,
        breakpoints: breakpoints,
        
    }
}